import {FaHome} from "react-icons/fa";
import {FaTowerBroadcast, FaXTwitter} from "react-icons/fa6";

import {Card} from "@/components/card/Card.tsx";
import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
import {ThirdPartyService} from "@/lib/queries/checks.ts";
import {ThirdPartyServiceComponent} from "@/lib/types/checks.ts";

interface CloudStatusSocialLinksProps {
  component?: ThirdPartyService | ThirdPartyServiceComponent;
}

export const CloudStatusSocialLinks = ({component}: CloudStatusSocialLinksProps) => {
  const {group, main_url, status_page_url, social_url} = component || {};

  if (!main_url && !status_page_url && !social_url) {
    return null;
  }

  return (
    <Card variant="cloudStatus" className="row justify-content-md-left">
      {main_url && (
        <a href={main_url} className="col-md-auto d-flex align-items-center" target="_blank" rel="noopener noreferrer">
          <TooltipIconRA icon={FaHome} className="text-black me-1" title="Home" />
          <span className="text-decoration-underline text-body-secondary">{group} Home Page</span>
        </a>
      )}
      {status_page_url && (
        <a
          href={status_page_url}
          className="col-md-auto d-flex align-items-center"
          target="_blank"
          rel="noopener noreferrer"
        >
          <TooltipIconRA icon={FaTowerBroadcast} className="text-black me-1" title="Status Page" />
          <span className="text-decoration-underline text-body-secondary">{group} Status Page</span>
        </a>
      )}
      {social_url && (
        <a
          href={social_url}
          className="col-md-auto d-flex align-items-center"
          target="_blank"
          rel="noopener noreferrer"
        >
          <TooltipIconRA icon={FaXTwitter} className="text-black me-1" title="Social" />
          <span className="text-decoration-underline text-body-secondary">{group} Status</span>
        </a>
      )}
    </Card>
  );
};
